import type {
  ChainModifiers,
  Entry,
  EntryFieldTypes,
  EntrySkeletonType,
  LocaleCode,
} from 'contentful';
import type { TypeLinkSkeleton } from './TypeLink';

export interface TypeCategorizedRichTextFields {
  title: EntryFieldTypes.Symbol;
  description: EntryFieldTypes.RichText;
  categories?: EntryFieldTypes.Array<EntryFieldTypes.Symbol>;
  link?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeLinkSkeleton>>;
  icon?: EntryFieldTypes.AssetLink;
}

export type TypeCategorizedRichTextSkeleton = EntrySkeletonType<
  TypeCategorizedRichTextFields,
  'categorizedRichText'
>;
export type TypeCategorizedRichText<
  Modifiers extends ChainModifiers = 'WITHOUT_UNRESOLVABLE_LINKS',
  Locales extends LocaleCode = LocaleCode,
> = Entry<TypeCategorizedRichTextSkeleton, Modifiers, Locales>;

export function isTypeCategorizedRichText<
  Modifiers extends ChainModifiers,
  Locales extends LocaleCode,
>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is TypeCategorizedRichText<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'categorizedRichText';
}
